import { render } from "./LanguageNotice.vue?vue&type=template&id=1169c011&scoped=true"
import script from "./LanguageNotice.vue?vue&type=script&lang=js"
export * from "./LanguageNotice.vue?vue&type=script&lang=js"

import "./LanguageNotice.vue?vue&type=style&index=0&id=1169c011&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1169c011"]])

export default __exports__